import { useMemo } from "react";
import { useLocale } from "../../intl";
import { useClientView } from "../context/ClientViewProvider";
import {
  runtimeBuyerQuizPath,
  runtimeBuyerQuizResultsPath,
  runtimeContactPath,
  runtimeDealerDirectoryPath,
  runtimeDealerProfilePath,
  runtimeHomePath,
  runtimeAccountPath,
  runtimeAccountComparePath,
  runtimeSignInPath,
  runtimeVehicleDetailPath,
  runtimeVehicleSearchPath,
  resolveContentCtaHref,
} from "../utils/routes";

export function useLocalizedRuntimePaths() {
  const { slug, manifest } = useClientView();
  const { locale } = useLocale();

  return useMemo(
    () => ({
      slug,
      locale,
      homePath: runtimeHomePath(slug, locale, manifest),
      vehicleSearchPath: runtimeVehicleSearchPath(slug, locale, manifest),
      vehicleDetailPath: (vehicleListingId) =>
        runtimeVehicleDetailPath(slug, vehicleListingId, locale, manifest),
      dealerDirectoryPath: runtimeDealerDirectoryPath(slug, locale, manifest),
      dealerProfilePath: (dealerSlug) => runtimeDealerProfilePath(slug, dealerSlug, locale, manifest),
      buyerQuizPath: runtimeBuyerQuizPath(slug, locale, manifest),
      buyerQuizResultsPath: runtimeBuyerQuizResultsPath(slug, locale, manifest),
      howItWorksPath: `${runtimeHomePath(slug, locale, manifest)}/como-funciona`,
      contactPath: runtimeContactPath(slug, locale, manifest),
      signInPath: runtimeSignInPath(slug, locale, manifest),
      accountPath: runtimeAccountPath(slug, locale, manifest),
      accountComparePath: runtimeAccountComparePath(slug, locale, manifest),
      accountSavedSearchesPath: `${runtimeAccountPath(slug, locale, manifest)}?section=searches`,
      accountNotificationsPath: `${runtimeAccountPath(slug, locale, manifest)}?section=notifications`,
      resolveCtaHref: (href) => resolveContentCtaHref(slug, href, locale, manifest),
    }),
    [slug, locale, manifest]
  );
}
